import {connect} from "react-redux";
import {Layer, Source} from "react-map-gl";
import {getGeojsonPoint6} from "../../../actions/map";
import React from "react";
import PropTypes from "prop-types";

function TripViewerOverlay(props) {
  const {tripData, tripStyle} = props;
  return (
    <>
      {tripData && tripData.geometry && <div>
        <Source id={"trip_data"} type="geojson" data={getGeojsonPoint6(tripData.geometry.points6)}/>
        <Layer type="line" source={"trip_data"} id={'tripLayer'}
               paint={{'line-color': tripStyle.color, 'line-width': tripStyle.weight}} layout={{'line-join': "round"}}
        />
      </div>}
    </>
  )
}

TripViewerOverlay.propTypes = {
  tripStyle: PropTypes.object,
  tripData: PropTypes.shape({
    geometry: PropTypes.object
  })
};

TripViewerOverlay.defaultProps = {
  tripStyle: {
    color: "#00bfff",
    opacity: 0.6,
    weight: 8
  }
};

const mapStateToProps = (state, ownProps) => {
  const viewedTrip = state.otp.ui.viewedTrip;
  return {
    tripData: viewedTrip
      ? state.otp.transitIndex.trips[viewedTrip.tripId]
      : null
  }
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(TripViewerOverlay);